import { createSlice, PayloadAction } from '@reduxjs/toolkit'
import {
  addBlockedUser,
  fetchAllBlockedUsers,
  unblockUser,
} from '@store/actions'
import { IBlockedUser } from '@dataTypes/blocked-user.type'

interface BlockedUserState {
  data: IBlockedUser[]
  loading: boolean
  error: string | null
}

const initialState: BlockedUserState = {
  data: [],
  loading: false,
  error: '',
}

const blockedUserSlice = createSlice({
  name: 'blockedUser',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchAllBlockedUsers.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        fetchAllBlockedUsers.fulfilled,
        (state, action: PayloadAction<IBlockedUser[]>) => {
          state.data = action.payload
          state.loading = false
        },
      )
      .addCase(fetchAllBlockedUsers.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to fetch blocked users'
        state.loading = false
      })

    builder
      .addCase(addBlockedUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        addBlockedUser.fulfilled,
        (state, action: PayloadAction<IBlockedUser>) => {
          state.data = [...state.data, action.payload]
          state.error = null
          state.loading = false
        },
      )
      .addCase(addBlockedUser.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to add blocked user'
        state.loading = false
      })

    builder
      .addCase(unblockUser.pending, (state) => {
        state.loading = true
        state.error = null
      })
      .addCase(
        unblockUser.fulfilled,
        (state, action: PayloadAction<string>) => {
          state.data = state.data.filter(
            (blockedUser) => blockedUser.blocked_user_id !== action.payload,
          )
          state.error = null
          state.loading = false
        },
      )
      .addCase(unblockUser.rejected, (state, action) => {
        state.error = action.error.message || 'Failed to unblock user'
        state.loading = false
      })
  },
})

export default blockedUserSlice.reducer
